import React from 'react';
import Zoom from 'react-medium-image-zoom';

const title = "Account Transactions";
const description = `The Account Transactions Report is a vital tool designed to provide a clear and organized view of all financial activity associated with various accounts. Users can easily navigate this data, utilizing filtering capabilities to isolate and examine transactions for a specific account, allowing for precise analysis, reconciliation, and tracking of individual account histories and balances. This functionality enhances data clarity and simplifies the process of monitoring financial flow.
`;

const images = [
    '/images/reports/purchase-by-supplier/purchase-by-supplier.png', // 0
];


const AccountTransactions: React.FC = () => {

    return (
        <div className="max-w-4xl lg:max-w-5xl min-h-screen bg-gray-50 flex gap-2">
            <div className="overflow-auto mx-auto flex-2">

                <div className="mb-6">
                    <h1 className="text-3xl font-bold pt-4 text-gray-900">
                        {title}
                    </h1>
                    <p className="text-gray-600 mt-4">
                        {description}
                    </p>
                    <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6 my-6">
                        <Zoom>
                            <img
                                src={images[0]}
                                alt={title}
                                className="w-full max-w-4xl h-auto border border-gray-200 rounded-lg shadow-sm mx-auto"/>
                        </Zoom>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AccountTransactions;
